import { Component, Input, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { DsTooltipPosition, Icons, IconStyles } from '@levelaccess/design-system';
import { Subscription } from 'rxjs';
import { $severity } from '../../../../shared/constants/accessibility';
import { EapColors } from '../../shared/eap-colors';
import {
  AuditFindingQAStatus,
  AuditFindingQAStatusUnresolved,
  getAuditFindingQAStatusUnresolved,
} from '../../../../shared/constants/audit-finding';
import { Api } from '../../../../shared/constants/api';
import { EvaluationStandards } from '../../../../shared/constants/manual-evaluation';
import { FeatureFlagCollection } from '../../../../shared/interfaces/feature-flag.interface';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-overdue-unresolved-findings-by-severity',
  templateUrl: './overdue-unresolved-findings-by-severity.component.html',
  standalone: false,
})
export class OverdueUnresolvedFindingsBySeverityComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();

  @Input()
  public findingSeverity: $severity;
  @Input()
  public severityLabel: string;
  @Input()
  public agingIssues: number;
  @Input()
  public severityTimeInterval: number;
  @Input()
  public scanId: string;
  @Input()
  public standard: EvaluationStandards;

  public Icons: typeof Icons;
  public IconStyles: typeof IconStyles;
  public EapColors: typeof EapColors;
  public auditFindingQAStatusUnresolved: WritableSignal<ReadonlyArray<AuditFindingQAStatus>>;
  public severity: typeof $severity;
  public DsTooltipPosition: typeof DsTooltipPosition;
  public Api: typeof Api;

  constructor(private featureFlagService: FeatureFlagService) {
    this.Icons = Icons;
    this.IconStyles = IconStyles;
    this.EapColors = EapColors;
    this.auditFindingQAStatusUnresolved = signal(AuditFindingQAStatusUnresolved);
    this.DsTooltipPosition = DsTooltipPosition;
    this.severity = $severity;
    this.Api = Api;
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.featureFlagService
        .variation$(FeatureFlagCollection.removeToReviewFromClientView, false)
        .subscribe((enabled: boolean): void => {
          this.auditFindingQAStatusUnresolved.set(getAuditFindingQAStatusUnresolved(Boolean(enabled)));
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
